import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useListCardsPaymentAccountCardAllGet } from "@/api-v3";
import {
  canSetDefault,
  isPhysicalCard,
  isSpendCard,
  isVirtualCard,
  toPaymentAccountCards,
} from "@/features/payments/types/payment-account-cards";
import { AppRoute } from "@/types/routes";

const LOGIN_PATH: string = AppRoute.LOGIN;

export const usePaymentMethods = () => {
  const location = useLocation();
  const { data, isLoading, error, refetch, isFetching } =
    useListCardsPaymentAccountCardAllGet({
      query: {
        refetchOnWindowFocus: false,
        enabled: location.pathname !== LOGIN_PATH,
      },
    });

  const cards = useMemo(() => toPaymentAccountCards(data?.data), [data]);
  const virtualCard = cards.find(isVirtualCard);
  const physicalCard = cards.find(isPhysicalCard);
  // Spend Cards are funded by the study and can never receive a payout, so they
  // are grouped apart from the cards that can.
  const spendCards = useMemo(() => cards.filter(isSpendCard), [cards]);
  const defaultPaymentMethod =
    virtualCard ??
    physicalCard ??
    cards.find((card) => canSetDefault(card.card_type));

  return {
    paymentMethodsLoading: isLoading,
    paymentMethodsError: error,
    refetchPaymentMethods: refetch,
    paymentMethodsFetching: isFetching,
    defaultPaymentMethod,
    paymentMethods: cards,
    defaultPaymentMethodId: defaultPaymentMethod?.id,
    virtualCard,
    physicalCard,
    spendCards,
    cards,
  };
};
